export const MONSTER_ICONS = {
  // Epic Monsters
  BARON_NASHOR: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_baron/hud/baron_square.png',
  RIFT_HERALD: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_riftherald/hud/sruriftherald_square.png',
  RIFTHERALD: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_riftherald/hud/sruriftherald_square.png',
  ELDER_DRAGON: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_dragon_elder/hud/dragon_square_elder.png',

  // Elemental Dragons
  FIRE_DRAGON: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_dragon_fire/hud/dragon_square_fire.png',
  WATER_DRAGON: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_dragon_water/hud/dragon_square_water.png',
  EARTH_DRAGON: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_dragon_earth/hud/dragon_square_earth.png',
  AIR_DRAGON: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_dragon_air/hud/dragon_air_square.png',
  HEXTECH_DRAGON: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_dragon_hextech/hud/icons2d/dragon_square_hextech.png',
  CHEMTECH_DRAGON: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_dragon_chemtech/hud/icons2d/dragon_square_chemtech.png',

  // Jungle Camps
  BLUE_SENTINEL: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_blue/hud/bluesentinel_square.png',
  RED_BRAMBLEBACK: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_red/hud/brambleback_square.png',
  GROMP: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_gromp/hud/gromp_square.png',
  MURK_WOLVES: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_murkwolf/hud/greatermurkwolf_square.png',
  CRIMSON_RAPTOR: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_razorbeak/hud/razorbeak_square.png',
  ANCIENT_KRUG: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_krug/hud/ancientkrug_square.png',
  RIFT_SCUTTLER: 'https://raw.communitydragon.org/latest/game/assets/characters/sru_crab/hud/crab_square_0.png',
  CONTROL_WARD:'https://ddragon.leagueoflegends.com/cdn/15.21.1/img/item/2055.png',
  STEALTH_WARD:'https://ddragon.leagueoflegends.com/cdn/15.21.1/img/item/2056.png',
  PLACED_WARD:'https://images.1v9.gg/wardskin/0.webp',


  // Voidgrub Horde
  HORDE: 'https://ddragon.leagueoflegends.com/cdn/5.5.1/img/ui/minion.png'
};
